import CardItem from 'components/sections/highlights/cardItem';
import { getShopifyGid } from 'lib/shopify/shopifyGid';
import { formatPriceByStoreLocale } from 'lib/shopify';
import styles from './step.module.scss';

const Step = ({
  data,
  locale,
  shopifyData,
  resources,
  pageTitle,
  stepIndex,
  selectedProducts,
  selectCallback,
  removeCallback,
  visible,
  addButtonText,
  removeButtonText,
}) => {
  const findShopifyData = product => {
    if (!shopifyData?.length) return {};
    const id = product.shopifyData?.variants?.[0].product_id;
    const result = shopifyData.find(
      shopifyProduct => shopifyProduct.productId === getShopifyGid('Product', id)
    );
    return result;
  };

  const isStepDisabled = selectedProducts.find(s => s.step === stepIndex);

  if (!visible) return null;

  return (
    <div className={styles.stepContainer}>
      <h2 className={styles.title}>{data.title}</h2>
      <div className={styles.productsContainer}>
        {data.products?.map((product, index) => {
          const isProductSelected = selectedProducts.find(
            s => s.step === stepIndex && s.product.id === product.id
          );
          const productShopifyData = findShopifyData(product);

          if (!productShopifyData || productShopifyData.outOfStock) return null;

          return (
            <div className={styles.cardWrapper}>
              <CardItem
                locale={locale}
                key={product.id}
                itemData={product}
                shopifyProduct={productShopifyData}
                globalModules={resources}
                itemIndex={index}
                pageTitle={pageTitle}
                hideAddToCart
                showAttributeLabel
              />
              {isProductSelected ? (
                <button
                  type="button"
                  className={styles.removeButton}
                  onClick={() => {
                    removeCallback(stepIndex);
                  }}
                >
                  {removeButtonText}
                </button>
              ) : (
                <button
                  type="button"
                  disabled={isStepDisabled || productShopifyData?.outOfStock}
                  className={styles.selectButton}
                  onClick={() => {
                    selectCallback(product, productShopifyData);
                  }}
                >
                  {addButtonText}
                  {' - '}
                  {formatPriceByStoreLocale({ locale, price: productShopifyData.productPrice })}
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Step;
